import React from "react";
import { useCellsCardCount } from "./AlarmOverviewDataGrid/hooks";
import { Grid, CircularProgress } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { useSelector } from "react-redux";
import { selectedGeoRegionsSelector } from "../../store/api/admin/selectors";
import { Region } from "../../store/api/admin/types";
import CardsDisplay from "../../components/Shared/Cards/CardsDisplay";

interface AlarmCardConfig {
  title: string;
  getValue: (data: any) => number;
  onClick?: () => void;
}

const CellsOverviewCards: React.FC = () => {
  const selectedGeoRegions = useSelector(selectedGeoRegionsSelector) as Region[];
  const regionNames = selectedGeoRegions.map(r => r.name);
  const { data, isLoading, error } = useCellsCardCount(regionNames);

  function scrollToAlarmsAndFilter(title: string): void {
    const target = document.getElementById("alarm-overview-alarms");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    window.dispatchEvent(
      new CustomEvent("alarm-overview:filter", {
        detail: { severity: title },
      })
    );
  }

  const alarmCards: AlarmCardConfig[] = [
    {
      title: "Total",
      getValue: (d) => (d?.radiating || 0) + (d?.nonRadiating || 0),
      onClick: () => scrollToAlarmsAndFilter("Critical"),
    },
    {
      title: "Operational Cells",
      getValue: (d) => d?.radiating || 0,
      onClick: () => scrollToAlarmsAndFilter("Major"),
    },
    {
      title: "Non Operational Cells",
      getValue: (d) => d?.nonRadiating || 0,
      onClick: () => scrollToAlarmsAndFilter("Minor"),
    },
  ];

  const renderAlarmCard = (config: AlarmCardConfig) => {
    const value = config.getValue(data);

    return (
      <div>
        <div className="text-2xl font-semibold tracking-tight" style={{ color: "var(--foreground)" }}>
          {value}
        </div>
      </div>
    );
  };

  return (
    <Grid container spacing={3}>
      {alarmCards.map((card) => (
        <Grid item xs={12} sm={6} md={4} key={card.title}>
          <CardsDisplay
            title={card.title}
            sx={{ backgroundColor: "var(--card)", height: "100%" }}
            contents={
              isLoading ? (
                <div className="flex justify-center items-center" style={{ minHeight: 50 }}><CircularProgress size={24} /></div>
              ) : (
                renderAlarmCard(card)
              )
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};


export default CellsOverviewCards;
